//State
const state = {
  isNewVictim: false,
};

//Getters
const getters= {
  isNewVictim(state) {
    return state.isNewVictim
  },
};

//Actions
const actions = {
  newVictim({commit}){
    commit('SET_IS_NEW_VICTIM', true)
  }
};

//Mutations
const mutations = {
  SET_IS_NEW_VICTIM (state, value) {
    state.isNewVictim = value
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}